module.exports = __webpack_public_path__ + "img/frame (238).e6645b5a.jpg";